import React from "react";
import styles from "./MinecraftItalia.module.scss";

const HeroSection: React.FC = () => (
    <div className={styles.heroBanner}>
        <img
            src="https://static.eblcraft.it/mcItalia/attachements/hubBackground.png" // cambia con la tua immagine
            alt="Sfondo Hero"
            className={styles.heroBackgroundImage}
        />
        <div className={styles.heroOverlay}/>

        {/* Box IP */}
        <div className={styles.heroIpBox}>
            <span><strong>PLAY.EBLCRAFT.IT</strong></span>
        </div>

        {/* Contenuto centrale */}
        <div className={styles.heroContent}>
            <img
                src="https://static.eblcraft.it/LogoEBLCraft.png"
                alt="Logo EBLcraft"
                className={styles.heroLogo}
            />

            <h1 className={styles.heroMainTitle}>IL SERVER<br/>PER OGNI PLAYER!</h1>

            <p className={styles.heroDescription}>
                Costruisci, combatti, esplora o cattura i Pokémon:<br/>
                <strong>Vanilla</strong>, <strong>Creative</strong>, <strong>FortCraft</strong>, <strong>Cobblemon</strong>, <strong>MobWars</strong> ti
                aspettano!
            </p>
        </div>
    </div>
);


interface ModeCardProps {
    title: string;
    image: string;
    version: string;
    description: React.ReactNode;
    tags?: { text: string; color: string }[];
}

const ModeCard: React.FC<ModeCardProps> = ({title, image, version, description, tags}) => (
    <div
        className={styles.modeCard}
        style={{backgroundImage: `url(${image})`}}
    >
        <div className={styles.modeTagsWrapper}>
            <div className={styles.modeVersion}>{version}</div>
            {tags?.map((tag, idx) => (
                <div
                    key={idx}
                    className={styles.modeTag}
                    style={{
                        backgroundColor: `${tag.color}33`, // colore trasparente
                        backdropFilter: "blur(6px)",
                        border: `1px solid ${tag.color}`,
                        color: tag.color
                    }}
                >
                    {tag.text}
                </div>
            ))}
        </div>
        <div className={styles.modeContent}>
            <div className={styles.modeTitle}>{title}</div>
            <div className={styles.modeDescription}>{description}</div>
        </div>
    </div>
);

const ModeSection: React.FC<{ title: string; cards: React.ReactNode[] }> = ({title, cards}) => (
    <>
        <p className={styles.sectionTitle}>{title}</p>
        <div className={styles.modeContainer}>
            {cards}
        </div>
    </>
);


const MinecraftItalia: React.FunctionComponent = () => {
    return (
        <div className={styles.container}>
            <HeroSection/>

            <div className={styles.sectionWrapper}>
                <ModeSection
                    title="MINIGAMES"
                    cards={[<ModeCard
                        key="mobwars"
                        title="MOBWARS"
                        image="https://static.eblcraft.it/mobwars.png"
                        version="1.21.1+"
                        description={
                            <>
                                <strong>Stanco delle classiche BedWars?</strong><br/>
                                Le <strong>MobWars</strong> sono la nuova frontiera: ogni squadra ha le sue candele da
                                difendere<br/>
                                e può acquistarne altre strategicamente. Il combattimento è tecnico, PvP 1.9+ con
                                cooldown sulle armi,<br/>
                                TeamCoins condivisi e build automatiche.<br/>
                                <br/>
                                Gioca con amici, scala la classifica e domina la mappa in un mix di strategia e azione!
                            </>
                        }
                    />,
                        <ModeCard
                            key="fortcraft"
                            title="FORTCRAFT"
                            image="https://static.eblcraft.it/fortcraft.png"
                            version="1.20.4+"
                            tags={[{text: "No Bedrock", color: "#a1a1a1"}]}
                            description={
                                <>
                                    <strong>Fortnite incontra Minecraft!</strong><br/>
                                    Riparati dietro i muri e nelle build della nostra community.<br/>
                                    Sfrutta armi a distanza, salti potenziati e un’arena completamente custom!<br/>
                                    <br/>
                                    Tutto questo su Vanilla puro, con un gameplay unico e senza mod da installare!
                                </>
                            }
                        />
                    ]}
                />

                <ModeSection
                    title="MODALITÀ"
                    cards={[
                        <ModeCard
                            key="cobblemon"
                            title="COBBLEMON 2"
                            image="https://static.eblcraft.it/servers/cobblemon/Spawn.png"
                            version="1.21.1"
                            tags={[
                                { text: "Custom Modpack", color: "#ff2828" },
                                { text: "No Bedrock", color: "#a1a1a1" }
                            ]}
                            description={
                                <>
                                    <strong>Pokémon e Minecraft, fusi alla perfezione.</strong><br/>
                                    Con il nostro <strong>modpack custom</strong>, vivi un’esperienza ottimizzata per i
                                    veri fan:<br/>
                                    cattura, allena e sfida allenatori, partecipa a tornei e costruisci la tua
                                    città!<br/>
                                    <br/>
                                    Un mondo pieno di biomi, Pokémon custom e una community sempre attiva.
                                </>
                            }
                        />,
                        <ModeCard
                            key="vanilla"
                            title="VANILLA"
                            image="https://static.eblcraft.it/vanilla.png"
                            version="1.21.4+"
                            tags={[
                                { text: "Twitch Sub Only", color: "#d981ff" }
                            ]}
                            description={
                                <>
                                    <strong>Il cuore pulsante di EBLCraft.</strong><br/>
                                    Crea la tua città, esplora il mondo, commercia con gli altri player e partecipa ad
                                    eventi community su larga scala.<br/>
                                    <br/>
                                    Nessun grief, nessun furto, solo un ambiente amichevole e protetto per costruire e
                                    vivere insieme.
                                </>
                            }
                        />,
                        <ModeCard
                            key="creative"
                            title="CREATIVE"
                            image="https://static.eblcraft.it/creative.png"
                            version="1.21.1+"
                            description={
                                <>
                                    <strong>Libera la tua immaginazione!</strong><br/>
                                    Costruisci senza limiti usando <strong>World
                                    Edit</strong>, <strong>Arceon</strong> e altri strumenti avanzati.<br/>
                                    Il nostro mondo è ottimizzato per builder di ogni livello, dai novizi agli
                                    esperti.<br/>
                                    <br/>
                                    Ideale per team di costruzione, progetti artistici o semplicemente rilassarti e
                                    creare.
                                </>
                            }
                        />
                    ]}
                />
            </div>
        </div>
    );
};

export default MinecraftItalia;
